// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"0ef05597","899":"04084333","935":"04084333"}[chunkId] + ".chunk.css";
};